"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrl = void 0;

var buildUrl = function buildUrl(base, endpoint) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var basis = "".concat(base, "/").concat(endpoint);
  var queryString = params ? Object.entries(params).reduce(function (accum, current) {
    return "".concat(accum + (accum.length === 0 ? '?' : '&')).concat(current[0], "=").concat(current[1]);
  }, '') : '';
  return "".concat(basis).concat(queryString);
};

exports.buildUrl = buildUrl;